import { faClipboard, faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Dispatch, SetStateAction, useRef, useState } from "react";
import UnForm from "../../../../Components/Form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import VisualizarAssinaturas from "../../../../Components/VisualizarAssinaturasEntregaChaves";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";
import {
    BaixarFormularioPDFController,
    CadastrarPesquisaRespondidaController,
    ListarPesquisaRespondidaController,
} from "../../../../Controllers/AssistenciaTecnica/Formularios/FormulariosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { FormatterRG } from "../../../../Validations/InputMasks";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import BlocoAssinaturaAssistenciaTecnica from "../../../../Components/CardsPages/BlocoAssinaturaAssistenciaTecnica";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { ACESSOS } from "../../../../Routes/Acessos";
import { IAcompanhamentosVistoria } from "../../../../Interfaces/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaInterfaces";

import BlocoAssinaturaEntregaChaves from "../../../../Components/CardsPages/BlocoAssinaturaEntregaChaves";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import saveAs from "file-saver";
import { ETAPA_ENTREGA_CHAVES } from "../../../../Constants/EntregaChaves";
import {
    GetTemplateFormularioController,
    CadastrarPesquisaSatisfacaoFormularioRespondidoController,
    GetTermoRecebimentoHTMLController,
    BuscarAgrupamentoFormularioController,
} from "../../../../Controllers/Geral/Formularios/FormulariosControllers";
import { ListarPerguntasERespostarFormController } from "../../../../Controllers/Geral/Formularios/PerguntasERespostas/PerguntasERespostasControllers";
import { IResponderPesquisaSatisfacao } from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";
import { useUserInfor } from "../../../../Context/User";
import { ListarContatosController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import { GetAtendimentoClienteController } from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";

interface IVisualizarFormularioProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    idFormulario: number;
    respondendoFormulario?: boolean;
    visualizandoFormRespondido?: boolean;
    idCaso?: number;
    cdEtapa?: string;
    exportarPdf?: boolean;
    nrAgrupamento?: string;
    row?: IAcompanhamentosVistoria["relatorioAcompanhamentoVistoria"][0];
    flAssinarTermo?: boolean;
}

export default function VisualizarFormulario(
    props: IVisualizarFormularioProps
) {
    const { ID_CASO, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const { id } = useModuloInfo();
    const { ID_ORGANIZACAO } = useUserInfor().OrgInfor;

    const flRemoverDeclaracao =
        ID_ORGANIZACAO === "3DF8B6E4-6F9E-488D-A4AB-F62F776B1562" ||
        ID_ORGANIZACAO === "D7C9509A-4B15-4C3F-BB7F-85998EE35FBA";

    const { Config } = useUserInfor();
    const ConfigVistoriaDTO = Config.ConfigVistoriaDTO;
    const ConfigAssistenciaTecnicaDTO = Config.ConfigAssistenciaTecnicaDTO;

    const [nomeRecebimento, setNomeRecebimento] = useState<string>("");
    const [isInvalid, setIsInvalid] = useState<string>("");

    const nomeRef = useRef<HTMLDivElement>(null);

    const selecionarNomeFormulario =
        (ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO === id &&
            ConfigVistoriaDTO.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_VIST) ||
        (ACESSOS.ASSISTENCIA.ID_MODULO === id &&
            ConfigAssistenciaTecnicaDTO.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_AT);

    const { execute: ListarContatos } = useAsyncEffect(
        () =>
            GetAtendimentoClienteController(ID_CASO ?? props.idCaso).then(
                (res) => ListarContatosController(res.ID_CONTA ?? 0)
            ),
        []
    );

    const {
        execute: BaixarFormularioPDF,
        loading: BaixarFormularioPDFLoading,
    } = useAsyncCallback(BaixarFormularioPDFController);
    const {
        value: ListarFormulario,
        loading: ListarFormularioLoading,
        // execute: updateList
    } = useAsyncEffect(
        async () => ListarPerguntasERespostarFormController(props.idFormulario),
        []
    );
    const {
        value: GetTemplateFormulario,
        loading: GetTemplateFormularioLoading,
    } = useAsyncEffect(
        () =>
            GetTemplateFormularioController(
                props.idFormulario,
                id,
                ID_CASO ?? props.idCaso
            ),
        []
    );

    const {
        value: ListarRespostas,
        loading: ListarPerguntasERespostasLoading,
    } = useAsyncEffect(async () => {
        if (ID_CASO || props.idCaso) {
            const nrAgrupamento = await BuscarAgrupamentoFormularioController(
                props.idFormulario,
                ID_CASO ?? props.idCaso
            );

            return ListarPesquisaRespondidaController(
                ID_CASO ?? props.idCaso,
                nrAgrupamento?.toString() ?? props.nrAgrupamento
            );
        }
    }, [props.visualizandoFormRespondido]);

    const primeiraResposta = ListarRespostas?.find(
        (lstResp) => ListarFormulario?.ID_FORMULARIO === lstResp.ID_FORMULARIO
    );
    function listaFormularioPorIDResposta() {
        let listaIDs: any = [];
        let listaRespostaIgual: any = [];
        ListarFormulario?.ListaPesquisaSatisfacaoPerguntaRespostas?.map(
            (listaPergunta: any) =>
                listaPergunta?.PesquisaSatisfacaoRespostas.map(
                    (resposta: any) => {
                        return listaIDs.push(resposta.ID_RESPOSTA);
                    }
                )
        );
        if (listaIDs.length > 0) {
            listaRespostaIgual = listaIDs.map((id: number) =>
                ListarRespostas?.find((resposta) => resposta.ID_RESPOSTA === id)
            );
        }
        return listaRespostaIgual.filter((value: any) => value);
    }
    const {
        execute: CadastrarPesquisaRespondida,
        loading: CadastrarPesquisaRespondidaLoading,
    } = useAsyncCallback(CadastrarPesquisaRespondidaController);

    const {
        execute: CadastrarPesquisaSatisfacaoFormularioRespondido,
        loading: CadastrarPesquisaSatisfacaoFormularioRespondidoLoading,
    } = useAsyncCallback(
        CadastrarPesquisaSatisfacaoFormularioRespondidoController
    );

    const descricaoFormulario = () => {
        if (ListarFormulario?.DS_FORMULARIO === "VISTORIA - ENTREGA CHAVES") {
            return ListarRespostas?.find(
                (idResposta) => idResposta.FL_NAO_CONFORME
            )
                ? "TERMO DE VISTORIA - VISTORIA NÃO CONFORME"
                : "TERMO DE VISTORIA - VISTORIA CONFORME";
        }
        return ListarFormulario?.DS_FORMULARIO;
    };

    const elementoParaPdfRef = useRef<HTMLDivElement>(null);

    const { loading: lstTermoRecebimentoLoading, value: lstTermoRecebimento } =
        useAsyncEffect(
            () =>
                GetTermoRecebimentoHTMLController(
                    props.idFormulario,
                    id,
                    ID_CASO ?? props.idCaso,
                    props.cdEtapa,
                    false
                ),
            []
        );

    const {
        execute: GetTermoRecebimentoHTML,
        loading: GetTermoRecebimentoHTMLLoading,
    } = useAsyncCallback(
        () =>
            GetTermoRecebimentoHTMLController(
                props.idFormulario,
                id,
                ID_CASO ?? props.idCaso,
                props.cdEtapa,
                true
            ).then((res) => {
                const binaryString = window.atob(res);
                const len = binaryString.length;
                const bytes = new Uint8Array(len);

                for (let i = 0; i < len; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }

                const blob = new Blob([bytes], { type: "application/pdf" });
                saveAs(blob, "Termo-Recebimento");
            }),
        []
    );

    const handleCadastrarPesquisaRespondida = (
        formData: IResponderPesquisaSatisfacao
    ) => {
        const listaRespondidos = formData.Respondidas?.map((respondida) => ({
            ...respondida,
            ID_FORMULARIO: props.idFormulario,
        }));
        //ALTERAR AQUI

        if (selecionarNomeFormulario)
            formData.Recebimento.DS_NOME = nomeRecebimento;

        if (props.flAssinarTermo) {
            CadastrarPesquisaSatisfacaoFormularioRespondido(ID_CASO, {
                ...formData,
                Respondidas: listaRespondidos,
                Recebimento: {
                    ...formData.Recebimento,
                    DT_ASSINATURA: new Date(
                        new Date().getTime() - 180 * 60000
                    ).toISOString(),
                    //data: diminui da data atual 180 minutos (GMT -3) padrão brasileiro. Depois a transforma em padrão ISO string
                    //necessário fazer isso pois o IDO usa o fuso GMT zero
                },
            }).then((res) => {
                props.setShow(false);
                updateAtendimento();
                ReloadHistorico();
            });
        } else {
            CadastrarPesquisaRespondida(ID_CASO, {
                ...formData,
                Respondidas: listaRespondidos,
                Recebimento: {
                    ...formData.Recebimento,
                    DT_ASSINATURA: new Date(
                        new Date().getTime() - 180 * 60000
                    ).toISOString(),
                    //data: diminui da data atual 180 minutos (GMT -3) padrão brasileiro. Depois a transforma em padrão ISO string
                    //necessário fazer isso pois o IDO usa o fuso GMT zero
                },
            }).then((res) => {
                props.setShow(false);
                updateAtendimento();
                ReloadHistorico();
            });
        }
    };

    const findDsComentario = (value: number) => {
        const findValue = ListarRespostas?.find(
            (resposta) => resposta.ID_PERGUNTA === value
        );
        return findValue?.DS_COMENTARIO || "";
    };
    return (
        <>
            <OrSpinner
                spinner="capys"
                loading={
                    ListarFormularioLoading ||
                    CadastrarPesquisaRespondidaLoading ||
                    CadastrarPesquisaSatisfacaoFormularioRespondidoLoading ||
                    ListarPerguntasERespostasLoading
                }
            >
                {props.exportarPdf && (
                    <>
                        <div className="flex-wrap modal-header pt-0 pb-3">
                            <div
                                className="w-100 d-flex justify-content-between align-itens-center modal-title h4"
                                id="contained-modal-title-vcenter"
                            >
                                <div className="d-flex align-itens-end w-100 justify-content-between">
                                    <div className="mt-2">
                                        <FontAwesomeIcon
                                            icon={faClipboard}
                                            className="fa-w-12 fa-lg mr-2"
                                        />
                                        Ver Formulário
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <button
                                            className="btn btn-success font-weight-bold justify-content-center"
                                            disabled={
                                                BaixarFormularioPDFLoading ||
                                                GetTermoRecebimentoHTMLLoading
                                            }
                                            onClick={() => {
                                                if (
                                                    props.cdEtapa ===
                                                    ETAPA_ENTREGA_CHAVES
                                                        .ENTREGA_REALIZADA_ASSINAR_TERMO
                                                        .CD_ETAPA
                                                ) {
                                                    GetTermoRecebimentoHTML();
                                                } else {
                                                    BaixarFormularioPDF(
                                                        props.idFormulario,
                                                        props.idCaso ?? 0,
                                                        props.nrAgrupamento
                                                    ).then((res) => {
                                                        if (res) {
                                                            saveAs(
                                                                res,
                                                                `Formulário-${props.idCaso}`
                                                            );
                                                        }
                                                    });
                                                }
                                            }}
                                        >
                                            {BaixarFormularioPDFLoading ||
                                            GetTermoRecebimentoHTMLLoading ? (
                                                <span className="d-flex justify-content-center align-items-center g-2">
                                                    <Spinner size="sm" />
                                                    Exportar como PDF
                                                </span>
                                            ) : (
                                                <>
                                                    <FontAwesomeIcon
                                                        icon={faFileDownload}
                                                        className="fa-w-6 fa-md mr-2"
                                                    />
                                                    Exportar como PDF
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.ID_TELA &&
                    props.row?.CD_ETAPA !==
                        ETAPA_ENTREGA_CHAVES.ENTREGA_REALIZADA_ASSINAR_TERMO
                            .CD_ETAPA && (
                        <div className="d-flex align-items-center justify-content-center mb-20 mt-5">
                            <h3>{descricaoFormulario()}</h3>
                        </div>
                    )}

                {props.flAssinarTermo &&
                    (GetTemplateFormularioLoading ? (
                        <SpinnerComponent />
                    ) : (
                        <div className="d-flex align-items-center justify-content-center mb-20 mt-5">
                            <h3
                                dangerouslySetInnerHTML={{
                                    __html: GetTemplateFormulario,
                                }}
                            ></h3>
                        </div>
                    ))}

                {!props.flAssinarTermo &&
                    props.row?.CD_ETAPA ===
                        ETAPA_ENTREGA_CHAVES.ENTREGA_REALIZADA_ASSINAR_TERMO
                            .CD_ETAPA &&
                    (lstTermoRecebimentoLoading ? (
                        <SpinnerComponent />
                    ) : (
                        <div className="my-5">
                            <div
                                ref={elementoParaPdfRef}
                                id="elemento-para-pdf"
                            >
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: lstTermoRecebimento,
                                    }}
                                ></div>
                            </div>
                        </div>
                    ))}

                {ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.ID_TELA &&
                    props.row?.CD_ETAPA !==
                        ETAPA_ENTREGA_CHAVES.ENTREGA_REALIZADA_ASSINAR_TERMO
                            .CD_ETAPA && (
                        <>
                            {" "}
                            <UnForm
                                handleSubmit={handleCadastrarPesquisaRespondida}
                            >
                                {ListarFormulario?.ListaPesquisaSatisfacaoPerguntaRespostas?.filter(
                                    (x) =>
                                        x.PesquisaSatisfacaoRespostas?.find(
                                            (x) => x.FL_ATIVO
                                        )
                                ).map((perguntaPai, index) => (
                                    <div
                                        key={perguntaPai.ID_PERGUNTA}
                                        className={`h-100 mb-5 wrap ${
                                            perguntaPai.ID_PERGUNTA_PAI &&
                                            "ml-25 mb-0 mt-0 mr-25"
                                        } ${!perguntaPai.FL_ATIVO && "d-none"}`}
                                    >
                                        <>
                                            <hr className="mb-5 mt-5" />
                                            <h4>{perguntaPai.DS_PERGUNTA}</h4>
                                        </>

                                        <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                            {perguntaPai.ID_TIPO_PERGUNTA !==
                                            3 ? (
                                                <>
                                                    {perguntaPai.PesquisaSatisfacaoRespostas?.filter(
                                                        (x) => x.FL_ATIVO
                                                    )?.map((resposta) => (
                                                        <React.Fragment
                                                            key={
                                                                resposta.ID_RESPOSTA
                                                            }
                                                        >
                                                            <li
                                                                className="m-5"
                                                                style={{
                                                                    height: 80,
                                                                    display:
                                                                        "flex",
                                                                    alignItems:
                                                                        "center",
                                                                    justifyContent:
                                                                        "center",
                                                                    flexDirection:
                                                                        "column",
                                                                    textAlign:
                                                                        "center",
                                                                }}
                                                            >
                                                                <UnForm.Input
                                                                    readOnly
                                                                    name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                    value={
                                                                        perguntaPai.ID_PERGUNTA
                                                                    }
                                                                    style={{
                                                                        display:
                                                                            "none",
                                                                    }}
                                                                    wrapperClassName="d-none"
                                                                />

                                                                {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                1 ? (
                                                                    <UnForm.Input
                                                                        name={`Respondidas.${index}.idRespostas.0`}
                                                                        label={
                                                                            resposta.DS_RESPOSTA
                                                                        }
                                                                        type={
                                                                            "radio"
                                                                        }
                                                                        wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                        style={{
                                                                            height: 35,
                                                                            width: 35,
                                                                        }}
                                                                        value={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                        disabled={
                                                                            props.visualizandoFormRespondido ===
                                                                            true
                                                                        }
                                                                        defaultChecked={ListarRespostas?.some(
                                                                            (
                                                                                res
                                                                            ) =>
                                                                                res.ID_RESPOSTA ===
                                                                                resposta.ID_RESPOSTA
                                                                        )}
                                                                    />
                                                                ) : null}

                                                                {perguntaPai.ID_TIPO_PERGUNTA ===
                                                                2 ? (
                                                                    <UnForm.Input
                                                                        type="checkbox"
                                                                        color="primary"
                                                                        name={`Respondidas.${index}.idRespostas`}
                                                                        label={
                                                                            resposta.DS_RESPOSTA
                                                                        }
                                                                        value={
                                                                            resposta.ID_RESPOSTA
                                                                        }
                                                                        wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                        style={{
                                                                            height: 35,
                                                                            width: 35,
                                                                        }}
                                                                        disabled={
                                                                            props.visualizandoFormRespondido ===
                                                                            true
                                                                        }
                                                                        defaultChecked={ListarRespostas?.some(
                                                                            (
                                                                                res
                                                                            ) =>
                                                                                res.ID_RESPOSTA ===
                                                                                resposta.ID_RESPOSTA
                                                                        )}
                                                                    />
                                                                ) : null}
                                                            </li>
                                                        </React.Fragment>
                                                    ))}
                                                </>
                                            ) : null}
                                        </ul>

                                        {ListarRespostas?.filter(
                                            (x) =>
                                                x.ID_PERGUNTA ===
                                                perguntaPai.ID_PERGUNTA
                                        ) &&
                                            ListarRespostas?.find(
                                                (x) =>
                                                    x.ID_PERGUNTA ===
                                                    perguntaPai.ID_PERGUNTA
                                            )?.RESPOSTA_JUSTIFICATIVA && (
                                                <UnForm.Textarea
                                                    name="Justificativa"
                                                    defaultValue={ListarRespostas?.find(
                                                        (x) =>
                                                            x.ID_PERGUNTA ===
                                                            perguntaPai.ID_PERGUNTA
                                                    )?.RESPOSTA_JUSTIFICATIVA?.map(
                                                        (ma) =>
                                                            ma.DS_JUSTIFICATIVA
                                                    )}
                                                    disabled
                                                />
                                            )}

                                        {!perguntaPai.ID_PERGUNTA_PAI && (
                                            <>
                                                <UnForm.Input
                                                    readOnly
                                                    name={`Respondidas.${index}.ID_PERGUNTA`}
                                                    value={
                                                        perguntaPai.ID_PERGUNTA
                                                    }
                                                    style={{
                                                        display: "none",
                                                    }}
                                                    wrapperClassName="d-none"
                                                />
                                                <UnForm.Textarea
                                                    label={
                                                        perguntaPai.ID_TIPO_PERGUNTA ===
                                                        3
                                                            ? "Resposta"
                                                            : "Comentário"
                                                    }
                                                    name={`Respondidas.${index}.DS_COMENTARIO`}
                                                    disabled={
                                                        props.visualizandoFormRespondido ===
                                                        true
                                                    }
                                                    defaultValue={findDsComentario(
                                                        perguntaPai.ID_PERGUNTA
                                                    )}
                                                />
                                            </>
                                        )}

                                        {perguntaPai.PerguntasFilhas?.map(
                                            (pergunta) => (
                                                <div className="h-100 mb-5 wrap ml-25 mb-0 mt-0 mr-25 false">
                                                    <div className="mt-8">
                                                        <h4>
                                                            {
                                                                perguntaPai.DS_PERGUNTA
                                                            }
                                                        </h4>
                                                    </div>
                                                    <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                                        {pergunta.ID_TIPO_PERGUNTA !==
                                                        3 ? (
                                                            <>
                                                                {pergunta.PesquisaSatisfacaoRespostas.map(
                                                                    (
                                                                        resposta
                                                                    ) => (
                                                                        <React.Fragment
                                                                            key={
                                                                                resposta.ID_RESPOSTA
                                                                            }
                                                                        >
                                                                            <li
                                                                                className="m-5"
                                                                                style={{
                                                                                    height: 80,
                                                                                    display:
                                                                                        "flex",
                                                                                    alignItems:
                                                                                        "center",
                                                                                    justifyContent:
                                                                                        "center",
                                                                                    flexDirection:
                                                                                        "column",
                                                                                    textAlign:
                                                                                        "center",
                                                                                }}
                                                                            >
                                                                                <UnForm.Input
                                                                                    readOnly
                                                                                    name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                                    value={
                                                                                        pergunta.ID_PERGUNTA
                                                                                    }
                                                                                    style={{
                                                                                        display:
                                                                                            "none",
                                                                                    }}
                                                                                    wrapperClassName="d-none"
                                                                                />

                                                                                {pergunta.ID_TIPO_PERGUNTA ===
                                                                                1 ? (
                                                                                    <UnForm.Input
                                                                                        name={`Respondidas.${index}.idRespostas.0`}
                                                                                        label={
                                                                                            resposta.DS_RESPOSTA
                                                                                        }
                                                                                        type={
                                                                                            "radio"
                                                                                        }
                                                                                        wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                                        style={{
                                                                                            height: 35,
                                                                                            width: 35,
                                                                                        }}
                                                                                        value={
                                                                                            resposta.ID_RESPOSTA
                                                                                        }
                                                                                        disabled={
                                                                                            props.visualizandoFormRespondido ===
                                                                                            true
                                                                                        }
                                                                                        defaultChecked={ListarRespostas?.some(
                                                                                            (
                                                                                                res
                                                                                            ) =>
                                                                                                res.ID_RESPOSTA ===
                                                                                                resposta.ID_RESPOSTA
                                                                                        )}
                                                                                    />
                                                                                ) : null}

                                                                                {pergunta.ID_TIPO_PERGUNTA ===
                                                                                2 ? (
                                                                                    <UnForm.Input
                                                                                        type="checkbox"
                                                                                        color="primary"
                                                                                        name={`Respondidas.${index}.idRespostas`}
                                                                                        label={
                                                                                            resposta.DS_RESPOSTA
                                                                                        }
                                                                                        value={
                                                                                            resposta.ID_RESPOSTA
                                                                                        }
                                                                                        wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                                        style={{
                                                                                            height: 35,
                                                                                            width: 35,
                                                                                        }}
                                                                                        disabled={
                                                                                            props.visualizandoFormRespondido ===
                                                                                            true
                                                                                        }
                                                                                        defaultChecked={ListarRespostas?.some(
                                                                                            (
                                                                                                res
                                                                                            ) =>
                                                                                                res.ID_RESPOSTA ===
                                                                                                resposta.ID_RESPOSTA
                                                                                        )}
                                                                                    />
                                                                                ) : null}
                                                                            </li>
                                                                        </React.Fragment>
                                                                    )
                                                                )}
                                                            </>
                                                        ) : null}
                                                    </ul>

                                                    {ListarRespostas?.find(
                                                        (idResposta) =>
                                                            idResposta.FL_NAO_CONFORME
                                                    )?.RESPOSTA_JUSTIFICATIVA[
                                                        index
                                                    ].ID_PERGUNTA ===
                                                        pergunta.ID_PERGUNTA && (
                                                        <UnForm.Textarea
                                                            name="Justificativa"
                                                            defaultValue={ListarRespostas?.find(
                                                                (idResposta) =>
                                                                    idResposta.FL_NAO_CONFORME
                                                            )?.RESPOSTA_JUSTIFICATIVA?.map(
                                                                (ma) =>
                                                                    ma.DS_JUSTIFICATIVA
                                                            )}
                                                            disabled
                                                        />
                                                    )}
                                                </div>
                                            )
                                        )}

                                        <hr />
                                    </div>
                                ))}
                                <>
                                    <div className="mb-6">
                                        {!flRemoverDeclaracao ? (
                                            <div>
                                                <h3>Recebimento:</h3>
                                                <span className="mb-5">
                                                    Declaro que a vistoria e os
                                                    serviços acima descritos
                                                    foram executados.
                                                </span>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        {selecionarNomeFormulario ? (
                                            <div className="row m-0 mt-5">
                                                <div
                                                    className="col col-6 col-md-6 m-0"
                                                    ref={nomeRef}
                                                    tabIndex={0}
                                                >
                                                    <label>Nome</label>
                                                    <UnForm.LazySelect
                                                        className={`form-control ${isInvalid}`}
                                                        name={`Recebimento.DS_NOME`}
                                                        controller={
                                                            ListarContatos
                                                        }
                                                        getDS={(c) => c.DS_NOME}
                                                        getKeyValue={(c) =>
                                                            c.DS_NOME
                                                        }
                                                        defaultValue={
                                                            listaFormularioPorIDResposta()
                                                                .length === 0 &&
                                                            props.flAssinarTermo
                                                                ? primeiraResposta?.DS_NOME
                                                                : listaFormularioPorIDResposta()[0]
                                                                      ?.DS_NOME
                                                        }
                                                        onChange={(e) => {
                                                            setIsInvalid("");
                                                            setNomeRecebimento(
                                                                e.target.value
                                                            );
                                                        }}
                                                        disabled={
                                                            props.visualizandoFormRespondido
                                                        }
                                                    >
                                                        <option></option>
                                                    </UnForm.LazySelect>
                                                    {isInvalid && (
                                                        <label
                                                            style={{
                                                                color: "#F64E60",
                                                                fontSize:
                                                                    "0.9rem",
                                                            }}
                                                        >
                                                            Selecione o nome
                                                        </label>
                                                    )}
                                                </div>
                                                <UnForm.Input
                                                    label={"RG/CPF"}
                                                    onChange={(e) =>
                                                        FormatterRG(
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={
                                                        props.visualizandoFormRespondido
                                                    }
                                                    defaultValue={
                                                        listaFormularioPorIDResposta()
                                                            .length === 0 &&
                                                        props.flAssinarTermo
                                                            ? primeiraResposta?.DS_RG
                                                            : listaFormularioPorIDResposta()[0]
                                                                  ?.DS_RG
                                                    }
                                                    registerOptions={{
                                                        required: "Insira o RG",
                                                    }}
                                                    name={`Recebimento.DS_RG`}
                                                    wrapperClassName="col-6 col-md-6 m-0"
                                                />
                                            </div>
                                        ) : (
                                            <div className="row m-0 mt-5">
                                                <UnForm.Input
                                                    label={"Nome"}
                                                    name={`Recebimento.DS_NOME`}
                                                    wrapperClassName="col-6 col-md-6 m-0"
                                                    defaultValue={
                                                        listaFormularioPorIDResposta()
                                                            .length === 0 &&
                                                        props.flAssinarTermo
                                                            ? primeiraResposta?.DS_NOME
                                                            : listaFormularioPorIDResposta()[0]
                                                                  ?.DS_NOME
                                                    }
                                                    disabled={
                                                        props.visualizandoFormRespondido
                                                    }
                                                    registerOptions={{
                                                        required:
                                                            "Insira o Nome",
                                                    }}
                                                />
                                                <UnForm.Input
                                                    label={"RG/CPF"}
                                                    onChange={(e) =>
                                                        FormatterRG(
                                                            e.target.value
                                                        )
                                                    }
                                                    disabled={
                                                        props.visualizandoFormRespondido
                                                    }
                                                    defaultValue={
                                                        listaFormularioPorIDResposta()
                                                            .length === 0 &&
                                                        props.flAssinarTermo
                                                            ? primeiraResposta?.DS_RG
                                                            : listaFormularioPorIDResposta()[0]
                                                                  ?.DS_RG
                                                    }
                                                    registerOptions={{
                                                        required: "Insira o RG",
                                                    }}
                                                    name={`Recebimento.DS_RG`}
                                                    wrapperClassName="col-6 col-md-6 m-0"
                                                />
                                            </div>
                                        )}

                                        {id ===
                                            ACESSOS.ASSISTENCIA.ID_MODULO && (
                                            <BlocoAssinaturaAssistenciaTecnica
                                                idCaso={ID_CASO ?? props.idCaso}
                                            />
                                        )}
                                    </div>

                                    <VisualizarAssinaturas
                                        idCaso={props.idCaso ?? 0}
                                        cdEtapa={props.cdEtapa}
                                    />
                                </>
                                {props.flAssinarTermo && (
                                    <BlocoAssinaturaEntregaChaves
                                        idCaso={ID_CASO ?? props.idCaso}
                                        flAssinarTermo={true}
                                    />
                                )}

                                <div className="d-flex justify-content-end">
                                    {props.respondendoFormulario && (
                                        <button
                                            type="submit"
                                            className="btn btn-success font-weight-bold mr-2 w-100px"
                                            onClick={(e) => {
                                                if (selecionarNomeFormulario) {
                                                    if (!nomeRecebimento) {
                                                        setIsInvalid(
                                                            "is-invalid"
                                                        );
                                                        e.preventDefault();

                                                        if (nomeRef.current)
                                                            nomeRef.current.focus();
                                                    } else setIsInvalid("");
                                                }
                                            }}
                                        >
                                            Enviar
                                        </button>
                                    )}
                                </div>
                            </UnForm>
                        </>
                    )}
            </OrSpinner>
        </>
    );
}
